import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { MessageCircle, DollarSign, AlertTriangle } from "lucide-react";
import { api, rd, reminderWhatsAppUrl } from "./posShared";
import PayModal from "./PayModal";

export default function CuentasPorCobrar({ settings }) {
  const [data, setData] = useState(null);
  const [pay, setPay] = useState(null);

  const load = useCallback(() => api.get("/pos/receivables").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const remind = (inv) => {
    const num = inv.customer_whatsapp;
    if (!num) return toast.error("El cliente no tiene WhatsApp/teléfono registrado");
    window.open(reminderWhatsAppUrl(inv, settings, num), "_blank");
  };

  if (!data) return <p className="text-neutral-400">Cargando...</p>;

  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Cuentas por cobrar</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <Stat l="Total pendiente" v={rd(data.total_pending)} />
        <Stat l="Vencido" v={rd(data.overdue_total)} accent />
        <Stat l="Facturas" v={data.count} />
      </div>

      <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-[11px] uppercase text-neutral-500">
            <tr><th className="px-4 py-3 text-left">Factura</th><th className="px-4 py-3 text-left">Cliente</th><th className="px-4 py-3 text-left">Vence</th><th className="px-4 py-3 text-right">Balance</th><th className="px-4 py-3 text-right">Acciones</th></tr>
          </thead>
          <tbody>
            {data.invoices.map((inv) => (
              <tr key={inv.id} data-testid={`cxc-row-${inv.id}`} className="border-t border-neutral-50">
                <td className="px-4 py-3 font-medium">{inv.number}</td>
                <td className="px-4 py-3">{inv.customer_name}</td>
                <td className="px-4 py-3">
                  {inv.credit_due_date || "—"}
                  {inv.overdue && <span className="ml-2 px-2 py-0.5 rounded-full text-xs bg-red-100 text-red-600 inline-flex items-center gap-1"><AlertTriangle size={11} /> Vencida</span>}
                </td>
                <td className="px-4 py-3 text-right font-medium text-rose">{rd(inv.balance)}</td>
                <td className="px-4 py-3">
                  <div className="flex gap-1.5 justify-end">
                    <button data-testid={`cxc-remind-${inv.id}`} onClick={() => remind(inv)} title="Recordar por WhatsApp" className="p-1.5 border border-neutral-200 rounded-lg text-rose hover:border-rose"><MessageCircle size={14} /></button>
                    <button data-testid={`cxc-pay-${inv.id}`} onClick={() => setPay(inv)} title="Registrar pago" className="p-1.5 border border-neutral-200 rounded-lg text-emerald-600 hover:border-emerald-400"><DollarSign size={14} /></button>
                  </div>
                </td>
              </tr>
            ))}
            {data.invoices.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-neutral-400">No hay cuentas pendientes de cobro. 🎉</td></tr>}
          </tbody>
        </table>
      </div>

      {pay && <PayModal invoice={pay} onClose={() => setPay(null)} onPaid={() => { setPay(null); load(); }} />}
    </div>
  );
}

const Stat = ({ l, v, accent }) => (
  <div className="bg-white border border-neutral-200 rounded-xl p-4">
    <p className="text-[11px] uppercase tracking-wider text-neutral-500">{l}</p>
    <p className={`text-2xl font-serif mt-1 ${accent ? "text-red-500" : "text-espresso"}`}>{v}</p>
  </div>
);
